import { render, staticRenderFns } from "./Appstore.vue?vue&type=template&id=b1942c9e"
import script from "./Appstore.vue?vue&type=script&lang=js"
export * from "./Appstore.vue?vue&type=script&lang=js"
import style0 from "./Appstore.vue?vue&type=style&index=0&id=b1942c9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../car/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports